import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { opened: { type: Boolean, default: false } }

  connect () {
    this.closeOnVisit = () => { this.openedValue = false }
    document.addEventListener('turbo:before-visit', this.closeOnVisit)
  }

  disconnect () {
    document.removeEventListener('turbo:before-visit', this.closeOnVisit)
  }

  toggle () {
    this.openedValue = !this.openedValue
  }

  openedValueChanged (opened) {
    this.element.classList.toggle('navbar-open', opened)
    document.body.classList.toggle('body-overflow', opened)
  }
}
